import api from "../../../../api";
import urls from "../../../../urls";
import type { SiteEnergyWizard } from "../../../../utils/backend-types";
import { OnboardingPhase } from "../../OnboardingWizard/OnboardingPhase/OnboardingPhase";
import { AssignmentType } from "../EnergyWizard";
import { MeterAssignment } from "./MeterAssignment/MeterAssignment";

type EnergyAssignmentProps = {
  energyWizard: SiteEnergyWizard;
  type: AssignmentType;
  isDone: boolean;
  onEnergyWizardUpdated: () => void;
};

function EnergyAssignment({
  energyWizard,
  type,
  isDone,
  onEnergyWizardUpdated
}: EnergyAssignmentProps) {
  async function updateEnergyWizard(type: AssignmentType) {
    let measurementDone = energyWizard.phases.meters.done;

    if (type === AssignmentType.MeasurementData) {
      measurementDone = true;
    }

    await api
      .post(urls.api.energyWizardUpdate(energyWizard.id), {
        id: energyWizard.id,
        phases: {
          meters: {
            done: measurementDone
          }
        }
      })
      .then(() => {
        onEnergyWizardUpdated();
      });
  }

  return (
    <OnboardingPhase isDone={isDone} type={type}>
      {type === AssignmentType.MeasurementData && (
        <MeterAssignment
          done={isDone}
          isBlocked={energyWizard.phases.meters.blocked}
          missingData={energyWizard.phases.meters.missingData}
          updateSiteWizard={updateEnergyWizard}
        />
      )}
    </OnboardingPhase>
  );
}

export { EnergyAssignment };
